<template>
<button
  v-if="$can('events.download.presenter')"
  :disabled="loading"
  @click="handlePresentationFile()"
  class="btn btn-fill btn-wd btn-success btn-block btn-router"
>
  Baixar Arquivo do Apresentador
</button>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import JSZip from 'jszip'
import Couchdb from 'src/services/Couchdb'
import { imageSuportService } from 'src/services/ImageSuport'
import downloadJs from 'downloadjs'

export default {
  name: 'BtnDownloadOldPresenter',

  data () {
    return {
      loading: false
    }
  },

  computed: {
    ...mapGetters('tickets', {
      ticketsWinners: 'winners'
    }),
    ...mapGetters('customers', {
      customers: 'modelById'
    })
  },

  methods: {
    ...mapActions(['changeExecution']),

    handlePresentationFile () {
      this.loading = true
      this.zipper()
        .then(res => {
          this.loading = false
          // console.log(res)
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    },

    async zipper () {
      this.changeExecution(true)
      let xmlText = this.makeXML()

      let zip = new JSZip()
      zip.file('sorteio.xml', xmlText, 'application/xml')

      let attachmentsPhotos = await this.getAttachmentPhotos()
      let resizedPhotos = await this.getResizedImages(attachmentsPhotos)

      for (let id in resizedPhotos) {
        zip.file(`fotos/${this.customers[this.ticketsWinners[id].customerId].uc}.jpg`, resizedPhotos[id].blob)
      }
      zip.generateAsync({ type: 'blob' })
        .then(function (blob) {
          downloadJs(blob, 'presentation.zip')
        })
      this.changeExecution(false)
    },

    async getAttachmentPhotos () {
      let attachmentsPhotos = []
      for (let id in this.ticketsWinners) {
        let anexo = false
        try {
          anexo = await Couchdb.getAttachment(this.customers[this.ticketsWinners[id].customerId]._id, 'image.jpg')
        } catch (e) {
          console.log('error', e)
        }
        attachmentsPhotos.push(anexo)
      }
      return attachmentsPhotos
    },

    async getResizedImages (attachmentsPhotos) {
      let resizedPhotos = []
      for (let file of attachmentsPhotos) {
        if (file) {
          let image = await imageSuportService.resizeImage(
            file,
            {
              canvasId: 'canvasPlace',
              maxWidth: 320,
              maxHeight: 240,
              maxQuality: 100
            }
          )
          resizedPhotos.push(image)
        }
      }
      return resizedPhotos
    },

    makeXML () {
      let xml = `<sorteio>${this.ticketsWinners.length}</sorteio>`
      for (let t of this.ticketsWinners) {
        xml += '<sorteado>'
        xml += `<nome>${this.customers[t.customerId].holder.toUpperCase()}</nome>`
        xml += `<uc>${this.customers[t.customerId].uc}</uc>`
        xml += `<imagem>${this.customers[t.customerId].uc}.jpg</imagem>`
        xml += '</sorteado>'
      }
      return xml
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Events/Actions/BtnDownloadOldPresenter.vue